import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import styles from './Account.module.css';
import { API_BASE_URL } from './Common';

function Account() {

  const [userData, setUserData] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false); // State to track delete confirmation
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/users`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        setUserData(response.data);
      } catch (error) {
        setError('Error fetching user data');
      }
    };

    fetchUserData();
  }, []);

  const handleChangeEmail = async () => {
  const newEmail = prompt("Enter your new email address:");
  if (newEmail) {
    try {
      const response = await axios.put(`${API_BASE_URL}/users/email`, {
        email: newEmail
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      setUserData(response.data); // Update user data with the updated email
      setSuccessMessage("Email updated successfully");
    } catch (error) {
      setError('Error updating email');
    }
  }
};

  const handleChangePassword = async (email) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/password-recovery`, { email });
    setSuccessMessage(response.data.message);
  } catch (error) {
    setError(error.response.data.message);
  }
};


  const handleDeleteAccount = async () => {
    try {
      const response = await axios.delete(`${API_BASE_URL}/delete-account`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}` // Assuming you store the access token in localStorage
        }
      });
      setSuccessMessage(response.data.message);
      // Redirect the user to the login page or display a message indicating successful account deletion
    } catch (error) {
      setError(error.response.data.error);
    }
  };

  const handleConfirmDelete = () => {
    setConfirmDelete(true); // Set confirmDelete to true when user confirms deletion
  };

  return (
    <div className={styles.loginContainer}>
      <h2>Conta</h2>
      {userData ? (
        <div>
          <p><strong>Nome:</strong> {userData[0].username}</p>
          <p><strong>Email:</strong> {userData[0].email}</p>
        </div>
      ) : (
        <div>A carregar...</div>
      )}

      <div className={styles.buttonGroup}>
      {/*<button type="button" className={styles.loginBtn} onClick={() => handleChangeEmail()}>Alterar Email</button>*/}
        <button type="button" className={styles.loginBtn} onClick={() => handleChangePassword(userData[0].email)}>Alterar Password</button>
        {confirmDelete ? (
          <>
            <button type="button" className={styles.confirmBtn} onClick={handleDeleteAccount}>Confirmar Eliminação</button>
            <button type="button" className={styles.cancelBtn} onClick={() => setConfirmDelete(false)}>Cancelar</button>
          </>
        ) : (<>
          {/*<button type="button" className={styles.loginBtn} onClick={handleConfirmDelete}>Eliminar Conta</button>*/}
        </>)}
      </div>
      {error && <div className={styles.errorMessage}>{error}</div>}
      {successMessage && <div className={styles.successMessage}>{successMessage}</div>}
    </div>
  );
}

export default Account;


